import { useMutation } from '@tanstack/react-query';

import { type CreateVoucherPayload } from '~/services/PromoService';
import { findExistingCode } from '~/services/PromoVoucherAiService';

export function useResolveVoucherAiWorkflow() {
  return useMutation({
    mutationFn: async ({ name, brand }: { name: string; brand: CreateVoucherPayload['brand'] }) =>
      findExistingCode('voucher', name, brand),
    retry: false,
  });
}
